function escapeCsvValue(value) {
    if (value == null) return '';
    let stringValue = String(value);

    stringValue = stringValue.replace(/"/g, '""');

    if (stringValue.includes(',') || stringValue.includes('\n') || stringValue.includes('"')) {
        stringValue = `"${stringValue}"`;
    }
    return stringValue;
}

function dictToCsvRow(hsh, columns) {
    let array: string[] = [];
    for (let i = 0; i < columns.length; i++) {
        if (!shouldExpoerColumn(columns[i])) {
            continue;
        }

        const col_id = columns[i].id;
        const disp_name = columns[i].disp_name;

        array.push(escapeCsvValue(hsh[col_id]));
    }

    return array.join(',');
}

function shouldExpoerColumn(column) {
    if (column.hidden) {
        return false;
    }

    if (column.type === 'action') {
        return false;
    }

    return true;
}

export function exportToCsvForDlz(filename, rows, base_url) {
    var uniqueCsns = new Set();
    var uniqueIsns = new Set();

    rows.forEach((row) => {
        if (row.csns != null) {
            const csns_from_csv = row.csns.split(',');
            csns_from_csv.forEach((csn) => {
                const csn_trimmed = csn.trim();
                if (csn_trimmed === '') {
                    return;
                }
                uniqueCsns.add(csn_trimmed);
            });
        }

        if (row.isns != null) {
            const isns_from_csv = row.isns.split(',');

            isns_from_csv.forEach((isn) => {
                const isn_trimmed = isn.trim();
                if (isn_trimmed === '') {
                    return;
                }
                uniqueIsns.add(isn_trimmed);
            });
        }
    });

    const header = 'Identifier,Property name,Rate,Rate units,Numeric value,Modifier,Error,Error type,Value units,Alpha value,Project\n';

    var content = '';
    uniqueCsns.forEach((csn) => {
        const url = base_url + '?csn=' + csn;
        content += csn + ',BioScience ELN Link,,,,,,,,' + url + ',' + '\n';
    });
    uniqueIsns.forEach((isn) => {
        const url = base_url + '?isn=' + isn;
        content += isn + ',BioScience ELN Link,,,,,,,,' + url + ',' + '\n';
    });

    const blob = new Blob([header + content], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement("a");
    if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
}

export function exportToCsv(filename, columns, rows) {
    const columnNames = columns.filter(shouldExpoerColumn).map((a) => a.disp_name);
    const header = columnNames.map(escapeCsvValue).join(',') + '\n';

    const csvContent = rows.map((a) => dictToCsvRow(a, columns)).join("\n");
    const blob = new Blob([header + csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement("a");
    if (link.download !== undefined) { // feature detection
        // Browsers that support HTML5 download attribute
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
}